import React from "react";

const Testimonials = () => {
  const otherTestimonials = [
    { id: 2, image: "/testimonials/t2.svg" },
    { id: 3, image: "/testimonials/t3.svg" },
  ];

  return (
    <div className="bg-gradient-to-b from-[#F5F7FA] to-white">
      <div className="relative max-w-[1200px] border-r border-l mx-auto px-4 py-16">
        <div className="text-center relative mb-16 z-20">
          <div className="flex items-center w-44 justify-center p-1 bg-gradient-to-b from-gray-100 to-white mx-auto mb-8 rounded-full">
            <div className="px-6 py-2 text-gray-600 font-medium bg-white border border-2 rounded-full geist-mono">
              Testimonials
            </div>
          </div>
          <h2 className="text-4xl font-semibold text-gray-900">
            Don't just take our word for it
          </h2>
        </div>

        <div className="max-w-3xl mx-auto border-t border-r border-l rounded-3xl">
          <div className="bg-gradient-to-b border border-8 border-white from-[#F5F7FA] to-white rounded-3xl p-8 text-center">
            <p className="text-[#344054] text-lg mb-8">
              SuperMetrics social analytics tool has provided great insights
              into social channels for our clients and has become an integral
              part of our content marketing strategies.
            </p>

            <div className="mb-8">
              <img
                src="/testimonials/mark.svg"
                alt="Mark Manson"
                className="w-16 h-16 rounded-full mx-auto mb-4"
              />
              <div className="font-semibold text-gray-900">Mark Manson</div>
              <div className="text-[#838E9E] text-sm">
                Project Manager at{" "}
                <span className="font-medium text-gray-900 border-b border-black">
                  Google
                </span>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2">
              <div className="bg-gradient-to-b from-[#1B91F0] to-white rounded-full">
                <div className="w-16 h-16 m-1 rounded-full overflow-hidden border border-8 border-white">
                  <img
                    src="/testimonials/mark.svg"
                    alt="Testimonial"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              {otherTestimonials.map((person) => (
                <div
                  key={person.id}
                  className="w-10 h-10 rounded-full overflow-hidden border-2 border-white"
                >
                  <img
                    src={person.image}
                    alt="Testimonial"
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
